// components/MainContent.tsx
import React, { useEffect } from "react";
import Statistics from "./Statistics";
import CircleButtons from "./CircleButtons";
import { DateInfo } from "./DateInfo";
import { StyleSheet, View, Text } from "react-native";
import { useDevice } from "../../../utils/hooks/useDevice";
import ProfileTournaments from "./Tournaments/ProfileTournaments";
import VipScreen from "./BuyVip/ProfileVipScreen";
import ChipScreen from "./BuyChips/ProfileChipScreen";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { userStatsRequest } from "../../../store/auth/authActions";
import { selectProfile } from "../../../store/auth/authReducer";

type MainContentProps = {
  activeTab: "main" | "chips" | "vip" | "tournaments";
  player?: {
    rank: number;
    playerId: string;
    username: string;
    avatarFileId: string | null;
    totalChips: number;
    level: number;
  };
};
type Nav = NativeStackNavigationProp<RootStackParamList, "BuyPackages">;

const MainContent = ({ activeTab, player }: MainContentProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(userStatsRequest());
  }, [dispatch]);
  const authUser = useSelector(selectProfile);
  const userToShow = player
    ? {
        username: player.username,
        avatarFileId: player.avatarFileId,
        chips: player.totalChips,
        level: player.level,
      }
    : authUser;
  const { statistics } = useSelector((state: RootState) => state.auth);

  const { isTablet, isSm, isMobile } = useDevice();

  const isPortrait = isMobile || isTablet || isSm;
  const { navigate } = useNavigation<Nav>();
  if (activeTab === "chips") {
    navigate("BuyPackages", { activeTab: "chips" });
    return null;
  }

  if (activeTab === "vip") {
    navigate("BuyPackages", { activeTab: "vip" });
    return null;
  }

  if (activeTab === "tournaments") {
    return <ProfileTournaments />;
  }
  const hasUser = !!userToShow;
  if (isPortrait) {
    return (
      <>
        <View style={styles.fullWidth}>
          <Statistics user={userToShow} />
        </View>
        <CircleButtons user={userToShow} />
        <DateInfo user={userToShow} />
      </>
    );
  }

  // Desktop layout
  return (
    <View style={styles.row}>
      <View style={{ width: isPortrait ? "42%" : "50%" }}>
        <Statistics user={userToShow} />
        <DateInfo user={userToShow} />
      </View>
      <View style={{ width: isPortrait ? "58%" : "50%" }}>
        <CircleButtons user={userToShow} />
      </View>
    </View>
  );
};

export default MainContent;
const styles = StyleSheet.create({
  fullWidthAndHeight: {
    width: "100%",
    height: "100%",
  },
  fullWidth: {
    width: "100%",
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.7)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    maxHeight: "90%",
    backgroundColor: "#112345",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#00f0ff",
    position: "relative",
    padding: 2,
    paddingTop: 0,
  },
  row: {
    flexDirection: "row",
    display: "flex",
  },
  halfWidth: {
    width: "50%",
  },
  placeholder: {
    fontSize: 20,
    color: "#fff",
    textAlign: "center",
  },
  tournamentTitle: {
    fontSize: 24,
    fontWeight: "900",
    color: "#d8d8d8", // light gray / silver tone
    textAlign: "center",
    marginVertical: 12,
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 2 },
    textShadowRadius: 3,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
});
